import { render, staticRenderFns } from "./end-screen.vue?vue&type=template&id=0d0261af&"
import script from "./end-screen.vue?vue&type=script&lang=ts&"
export * from "./end-screen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports